module.exports = __webpack_public_path__ + "static/IBMPlexSans-Bold-6978a9ac448c2b629d1da33303d7087b.woff";